import { useEffect, useState } from 'react';
import { Row, Col, Card, Collapse, message } from 'antd';
import { useParams } from "react-router";
import { NavLink } from 'react-router-dom';
import LoaderComponent from '../../Loader';
import API from "../../../services/API";
import RefferedByMe from './ReferredByMe';
import RefferalPayouts from './ReferralPayouts';
import ReferralLinks from './ReferralLinks';
import { PersistedCollapse } from '../../PersistedSections';

const { Panel } = Collapse;
function Referrals({
  data = {},
  loading,
}) {
  const { userId } = useParams();
  const [referralLinks, setReferralLinks] = useState(false);

  const getReferralLinks = async () => {
    try {
      const referralLinks = await API.getReferralLink({ userId });
      setReferralLinks(referralLinks);
    } catch (error) {
      message.error("Referral Link for this user is unavailable!");
    }
  };
  
  useEffect(() => {
    getReferralLinks();
  }, []);

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <Card bordered={false} className="criclebox tablespace mb-16">
          <Row className="profile-box-container" gutter={[30, 30]}>
            <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
              <h4>Referred By</h4>
              {data.hasOwnProperty('referredBy') ?
                !!data?.referredBy ?
                  <NavLink to={`/user/${data?.referredBy?.value}`}>
                    <span className="label" style={{ textDecoration: 'underline' }}>{data?.referredBy?.value}</span>
                  </NavLink>
                  : <p style={{ background: '#f6f6f6', padding: 12 }}></p>
                : 'N/A'}

            </Col>
          </Row>
          <Row style={{ marginLeft: 14, marginBottom: 14 }}>
            <Col xs={24} xl={24} sm={24} md={24}>
              <PersistedCollapse name="referral-sections" defaultActiveKey={[1, 2, 3]}>
                {/* User Scores */}
                <Panel header="Referred By Me" key="1">
                  <Card>
                    <RefferedByMe refData={data.referredByMe} />
                  </Card>
                </Panel>
                <Panel header="Referral Payouts" key="2">
                  <Card>
                    <RefferalPayouts refData={data.referralPayouts} />
                  </Card>
                </Panel>
                <Panel header="Referral Links" key="3">
                  <Card>
                    <ReferralLinks refData={referralLinks} />
                  </Card>
                </Panel>
              </PersistedCollapse>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
}

export default Referrals;
